/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Ten_Minutes_BodyInputs */



/**
* | output |
* | --- |
* | "Ready to wrap up and see your feedback?" |
*
* @param {Practice_Session_Ten_Minutes_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_ten_minutes_body = /** @type {((inputs?: Practice_Session_Ten_Minutes_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Ten_Minutes_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Klaar om af te ronden en je feedback te bekijken?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prêt·e à conclure et à voir votre feedback ?")
	return /** @type {LocalizedString} */ ("Ready to wrap up and see your feedback?")
});